import { createUseStyles, Styles } from '../../web-styles'
import { ANIMATION_DURATION } from './toast.web'

interface UpsellModalStyles {
  toastContainer: Styles
  toastSubContainer: Styles
  toastMessageText: Styles
  closeButton: Styles
  progressBar: Styles
  fadeIn: Styles
  fadeOut: Styles
}

interface ToastPropsStyles {
  hasErrored: boolean
}

const TOAST_CONTAINER_WIDTH = 335
const PROGRESS_BAR_HEIGHT = 2

export const useStyles = createUseStyles<UpsellModalStyles, ToastPropsStyles>((theme) => {
  return {
    '@keyframes fadein': {
      from: { opacity: theme.opacity.transparent, bottom: theme.calcUnit(0) },
      to: { opacity: theme.opacity.opaque, bottom: theme.calcUnit(theme.spacing.s16) },
    },

    '@keyframes fadeout': {
      from: { opacity: theme.opacity.opaque, bottom: theme.calcUnit(theme.spacing.s16) },
      to: { opacity: theme.opacity.transparent, bottom: theme.calcUnit(0) },
    },

    '@keyframes progress': {
      from: { width: '0%' },
      to: { width: '100%' },
    },

    fadeIn: {
      animation: '$fadein 1.5s',
    },
    fadeOut: {
      animation: '$fadeout 1s',
    },

    toastContainer: ({ hasErrored }) => {
      return {
        display: 'flex',
        flexDirection: 'row',
        width: theme.calcUnit(TOAST_CONTAINER_WIDTH),
        backgroundColor: hasErrored ? theme.colors.webErrorColor : theme.colors.webSuccessBackground,
        position: 'fixed',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: theme.zIndex.highestLevel,
        bottom: theme.calcUnit(theme.spacing.s16),
        borderRadius: theme.calcUnit(theme.borderRadius.roundedDefault),
        '& button': {
          backgroundColor: hasErrored ? theme.colors.webErrorColor : theme.colors.webSuccessBackground,
        },
        ...theme.breakpoint.up<Styles>('lg', {
          left: 'auto',
          transform: 'none',
          right: theme.calcUnit(theme.spacing.s10),
        }),
      }
    },
    toastSubContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      paddingInline: theme.calcUnit(theme.spacing.s2),
      paddingTop: theme.calcUnit(theme.spacing.s3),
      paddingBottom: theme.calcUnit(theme.spacing.s3),
    },
    toastMessageText: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.calcUnit(theme.spacing.s1),
    },
    closeButton: {
      cursor: 'pointer',
    },
    progressBar: {
      position: 'absolute',
      bottom: theme.calcUnit(0),
      left: theme.calcUnit(0),
      height: theme.calcUnit(PROGRESS_BAR_HEIGHT),
      backgroundColor: theme.colors.lightTextColor,
      animation: `$progress ${ANIMATION_DURATION}ms linear`,
    },
  }
})
